import { Component, Input, OnInit,HostListener } from '@angular/core';
import { AlertController, MenuController,LoadingController, ModalController,AnimationController, Platform } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-attributes-list-options',
  templateUrl: './attributes-list-options.component.html',
  styleUrls: ['./attributes-list-options.component.scss'],
})
export class AttributesListOptionsComponent  implements OnInit {

  @Input() product_values:any = [];

  constructor(public modalCtrl: ModalController,public db:DataService) { } 

  ngOnInit() {

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }


  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }



  add(selected_item){
    this.product_values.map(res=>{
       if(selected_item.options == res.options){
        res['isActive'] = true;
        let data = {'status': 'success','data':selected_item};
        this.modalCtrl.dismiss(data);
       }else{
        res['isActive'] = false;
       }
    })
  }

  add_warehous(selected_item){
    this.product_values.map(res=>{
       if(selected_item.options == res.options){
        res['isActive'] = res['isActive'] ? false : true;
       }
    })
  }

  select_all(array_list){
    // let array:any = [];
    array_list.map(res=>{
      res['isActive'] = true;
      // array.push({'center':res.value});
    })
    // this.db.centres_list = array;
    // this.db.alert_animate.next(this.db.centres_list.length + ' centers selected')
    let data = {'status': 'success','data':array_list}
    this.modalCtrl.dismiss(data);
  }

  save(){

    let list = this.product_values.filter(r=>{return r['isActive'] == true})
    console.log(list);
    if(list.length == 0){
      this.db.alert('Please select any of option');
    }else{
      // this.db.centres_list = [];
      // list.map(res=>{
      //   this.db.centres_list.push({'center':res.value});
      // })
      // this.db.alert_animate.next(this.db.centres_list.length + ' centers selected');
      let data = {'status': 'success','data':this.product_values}
      this.modalCtrl.dismiss(data);
    }
  }

  close_modal(){
    // this.db.centres_list = [];
    this.modalCtrl.dismiss();
  }

}
